import { Box, SxProps, Theme, Typography } from "@mui/material";
import { intl } from "LocaleWrapper";
import { GeneralEntityChangeFragment as EntityChange } from "__generated__/components/entityHistory/graphql/entityHistory.fragments.generated";
import { ChangeType } from "__generated__/enums";
import EntityHistoryPathLabels from "../EntityHistoryPathLabels";
import { changeColor, changeIcon } from "components/entityHistory/utils/entityHistory.utils";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

type EntityRef = {
	changeType: ChangeType | null;
	entityKey: EntityChange["entityKey"];
	path: EntityChange["path"];
};

const GroupHeader = ({ entity, fontSize = 13, sx }: {
	entity: EntityRef;
	fontSize?: number;
	sx?: SxProps<Theme>;
}) => {
	const color = entity.changeType ? changeColor[entity.changeType] : "#888";

	return (
		<>
			<Box sx={{ ...sx, borderLeft: `3px solid ${color}`, pl: 1 }}>
				{entity.changeType ? changeIcon[entity.changeType] : (
					<InfoOutlinedIcon sx={{ fontSize: 18, color: "#888" }} />
				)}
			</Box>
			<Box sx={sx}>
				{entity.path.length > 1 ? (
					<EntityHistoryPathLabels path={entity.path} skipRoot />
				) : (
					<Typography component="span"
						fontSize={fontSize}
						color="text.primary"
						fontWeight="500">
						{intl.formatMessage({ id: entity.entityKey.languageKey })}
					</Typography>
				)}
			</Box>
		</>
	);
};

export default GroupHeader;
